var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("CabeceraTabla", {
        attrs: { permisoAccion: _vm.accionCrear },
        scopedSlots: _vm._u([
          {
            key: "izquierda",
            fn: function() {
              return [
                _c("BuscadorMantenedor", {
                  attrs: { filter: _vm.funcionFiltrar }
                })
              ]
            },
            proxy: true
          },
          {
            key: "centro",
            fn: function() {
              return [
                _c("ExportarAgGridButton", {
                  attrs: {
                    permisoAccion: _vm.accionExportar,
                    "column-defs": _vm.enrichedGridOptions
                      ? _vm.enrichedGridOptions.columnDefs
                      : _vm.gridOptions.columnDefs,
                    "row-data": _vm.lstEnvios,
                    "exported-file-name": "EnvioDeInformacion"
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "derecha",
            fn: function() {
              return [
                _c("CrearButton", {
                  attrs: { permisoAccion: _vm.accionCrear },
                  on: {
                    click: function($event) {
                      return _vm.handleCrearClick()
                    }
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("MantenedorGridTodos", {
        attrs: {
          "grid-options": _vm.gridOptions,
          "funcionalidad-id": _vm.funcionalidad,
          "row-data": _vm.lstEnvios,
          "test-id": "Envio"
        },
        on: {
          gridOptionsEnriched: function($event) {
            _vm.enrichedGridOptions = $event
          }
        }
      }),
      _c("ConfirmacionEliminar", {
        attrs: {
          show: _vm.isConfirmacionEliminarActivo,
          titulo: "Eliminar Envío de Información",
          mensaje: { entidad: "el Envio de Información" }
        },
        on: {
          aceptar: _vm.handleConfirmacionEliminar,
          cancelar: _vm.cerrarModalCrud
        }
      }),
      _c("Confirmation", {
        attrs: {
          show: _vm.mostrarInactivoEliminar,
          titulo: "Eliminar Envío de Información",
          mensaje:
            "El Servicio tiene envíos asociados, por esta razón no se podrá realizar la eliminación",
          mostrarBoton: false,
          textoBtnSi: "Aceptar"
        },
        on: {
          modalConfirmationEmit: function($event) {
            _vm.mostrarInactivoEliminar = false
          }
        }
      }),
      _vm.isModalCrearActivo
        ? _c("CrearEnvioInformacionModal", {
            on: { cerrar: _vm.cerrarModalCrud, crear: _vm.handleCrearOrEditar }
          })
        : _vm._e(),
      _vm.isModalEditarActivo
        ? _c("EditarEnvioInformacionModal", {
            attrs: { id: _vm.idEnvio },
            on: {
              cerrar: _vm.cerrarModalCrud,
              guardar: _vm.handleCrearOrEditar
            }
          })
        : _vm._e(),
      _vm.isModalVerActivo
        ? _c("VerDetalleEnvioInformacionModal", {
            attrs: { id: _vm.idEnvio },
            on: { cerrar: _vm.cerrarModalCrud }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }